module.exports = __webpack_public_path__ + "static/media/itunes.bc44524e.png";